import { defineComponent as _defineComponent } from 'vue'
import {useRoute} from 'vue-router';
import {ref, onBeforeMount} from 'vue';
import {getPoster} from '@/api/miscellaneous';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExtensionImages',
  setup(__props, { expose }) {
  expose();

const route = useRoute();

const src = ref<string>('');
onBeforeMount(() => {
    const {type} = route.query;
    if (type) {
        getImage();
    } else {
        src.value = `https://mdd-static.oss-cn-hangzhou.aliyuncs.com/wechat/h5/ad.png`;
    }
});

const getImage = () => {
    const {id} = route.query;
    getPoster({id: id as string, type: 'Shop'}).then(res => {
        src.value = res as string;
    });
};

const __returned__ = { route, src, getImage, useRoute, ref, onBeforeMount, getPoster }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})